import winSoundUrl from '../assets/sounds/pl-notification.wav'
import { logger, LogContext } from './logger'

// plc-app's notification sound, loaded up front so it starts with the celebration rather than after a fetch
const winSound = new Audio(winSoundUrl)
winSound.preload = 'auto'

export const playWinSound = () => {
  winSound.currentTime = 0
  // obs browser sources allow autoplay, a regular tab blocks it until the page has been clicked
  winSound.play().catch((error: Error) => {
    logger.warn(LogContext.OVERLAY, 'Win sound blocked', { reason: error.name })
  })
}
